// extracted by mini-css-extract-plugin
export var active = "_ky-2";
export var recordingDot = "_ky-1";
export var recordingIndicator = "_ky-0";